import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiUserPayment from "../../../core/api/api.userPayment";

export const ViewModal = ({ showModalUserPayment, setShowModalUserPayment, selectedUserPayment }) => {
  const handleClose = () => {
    setShowModalUserPayment(false);
  };
  const [itam, setUserPayment] = useState();
  const checkAndShowItem = (item) => {
    if (item) return item;
    else return "---";
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedUserPayment > 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response = await ApiUserPayment.getUserPaymentById(selectedUserPayment);
          if (response.succeeded == true) {
            setUserPayment(response.data);
          }
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="lg" onHide={handleClose} show={showModalUserPayment}>
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات پرداخت </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="border-bottom mb-3">
            <h4>اطلاعات فردی</h4>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">نام و نام خانوادگی </div>
              <div className="mt-2">{checkAndShowItem(itam?.userFullName)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">شماره همراه </div>
              <div className="mt-2">{checkAndShowItem(itam?.phoneNumber)}</div>
            </Col>
          </Row>
          <Row className="border-bottom mb-3 mt-5">
            <h4>اطلاعات تراکنش</h4>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">شماره تراکنش</div>
              <div className="mt-2">{checkAndShowItem(itam?.id)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">شماره درخواست</div>
              <div className="mt-2">{checkAndShowItem(itam?.orderId)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">مبلغ</div>
              <div className="mt-2">{checkAndShowItem(itam?.rialAmount?.toLocaleString())}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">وضعیت</div>
              <div className="mt-2">{checkAndShowItem(itam?.userPaymentStatusS)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">تاریخ انجام </div>
              <div className="mt-2">{checkAndShowItem(itam?.paymentDate)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">زمان انجام </div>
              <div className="mt-2">{checkAndShowItem(itam?.paymentTime)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">کد پیگیری </div>
              <div className="mt-2">{checkAndShowItem(itam?.trackingCode)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">شماره توکن </div>
              <div className="mt-2" style={{ wordBreak: "break-all" }}>
                {checkAndShowItem(itam?.tokenNumber)}
              </div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">شماره ای پی </div>
              <div className="mt-2" style={{ wordBreak: "break-all" }}>
                {checkAndShowItem(itam?.userIp)}
              </div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">درگاه</div>
              <div className="mt-2">{checkAndShowItem(itam?.userPaymentTypeTitle)}</div>
            </Col>
            <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
              <div className="fw-bold text-muted">شماره کارت واریز کننده </div>
              <div className="mt-2">{checkAndShowItem(itam?.cardNumberPayment)}</div>
            </Col>
            {itam?.description && (
              <Col xs="12" className="mt-2 mb-5">
                <div className="fw-bold text-muted">توضیحات</div>
                <div className="mt-2" style={{ wordBreak: "break-all" }}>
                  {itam?.description}
                </div>
              </Col>
            )}
          </Row>
          {itam?.basket && (
            <Row className="border-bottom mb-3 mt-5">
              <h4>اطلاعات سبد خرید</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted">شماره سبد </div>
                <div className="mt-2">{checkAndShowItem(itam?.basket?.id)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted">مبلغ اصلی </div>
                <div className="mt-2">{checkAndShowItem(itam?.basket?.originalPrice.toLocaleString())}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted">مبلغ نهایی </div>
                <div className="mt-2"> {checkAndShowItem(itam?.basket?.price.toLocaleString())}</div>
              </Col>
            </Row>
          )}
          {itam?.userPaymentTypeAccount && (
            <Row className=" mb-3 mt-5">
              <h4>اطلاعات حساب</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> نام بانک : </div>
                <div className="mt-2"> {checkAndShowItem(itam.userPaymentTypeAccount.bank)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> نام صاحب حساب : </div>
                <div className="mt-2"> {checkAndShowItem(itam.userPaymentTypeAccount.accountOwnerName)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره حساب : </div>
                <div className="mt-2"> {checkAndShowItem(itam.userPaymentTypeAccount.accountNumber)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> نام صاحب کارت : </div>
                <div className="mt-2"> {checkAndShowItem(itam.userPaymentTypeAccount.cardOwnerName)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره کارت : </div>
                <div className="mt-2"> {checkAndShowItem(itam.userPaymentTypeAccount.cardNumber)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره شبا : </div>
                <div className="mt-2" style={{ wordBreak: "break-all" }}>
                  {checkAndShowItem(itam.userPaymentTypeAccount.shebaNumber)}
                </div>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
